import React from "react";
import { Button, Form, Icon, Modal } from "semantic-ui-react";
import IdentityForm from "@common/components/shared/forms/IdentityForm";
import useIdentityFormModal from "@common/components/hooks/useIdentityFormModal";
import { FormProvider } from "react-hook-form";

const IdentityFormModal = () => {
  const {
    data: { open, title },
    methods,
    closeModal,
    onSubmit,
    isValidPhoto,
  } = useIdentityFormModal();

  return (
    <Modal open={open} onClose={closeModal} size="small" centered={false}>
      <Modal.Header>{title}</Modal.Header>
      <Modal.Content>
        <FormProvider {...methods}>
          <Form id="identityForm" onSubmit={methods.handleSubmit(onSubmit)}>
            <IdentityForm />
          </Form>
        </FormProvider>
      </Modal.Content>
      <Modal.Actions>
        <Button type="button" floated="left" onClick={closeModal} color="blue">
          <Icon name="arrow left" />
          Back
        </Button>
        <Button
          type="submit"
          disabled={!methods.formState.isValid || !isValidPhoto}
          form="identityForm"
          color="green"
        >
          Submit
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default IdentityFormModal;
